import { AstraFiEmployeeUserCardStatus } from "../../push-to-card";
import { schemes, zSchema as z } from "../../schema-validation";

export const cardSchema = z.object({
  card_company: z.string(),
  card_type: z.enum(["debit"]),
  exp_date: z.string(),
  first_name: z.string(),
  id: schemes.uuid(),
  last_four: z.string(),
  last_name: z.string(),
  status: z.nativeEnum(AstraFiEmployeeUserCardStatus),
});

export type Card = z.infer<typeof cardSchema>;
